export const BASE_ROUTE = "auth/sharing/token/:token";
